/**
 * VueLayers
 * Web map Vue components with the power of OpenLayers
 *
 * @package vuelayers
 * @author Vladimir Vershinin <ghettovoice@gmail.com>
 * @version 0.11.37
 * @license MIT
 * @copyright (c) 2017-2021, Vladimir Vershinin <ghettovoice@gmail.com>
 */
import Vue from 'vue';

var withFillStrokeStyle = {
  methods: {
    /**
     * @param {Fill|Vue|undefined} fill
     * @return {void}
     * @protected
     */
    setFill: function setFill(fill) {
      fill = fill instanceof Vue ? fill.$style : fill;

      if (fill !== this._fill) {
        /**
         * @type {Fill|undefined}
         * @private
         */
        this._fill = fill;
      }

      if (this.$style && fill !== this.$style.getFill()) {
        this.$style.setFill(fill);
        this.scheduleRefresh();
      }
    },

    /**
     * @param {Stroke|Vue|undefined} stroke
     * @return {void}
     * @protected
     */
    setStroke: function setStroke(stroke) {
      stroke = stroke instanceof Vue ? stroke.$style : stroke;

      if (stroke !== this._stroke) {
        /**
         * @type {Stroke|undefined}
         * @private
         */
        this._stroke = stroke;
      }

      if (this.$style && stroke !== this.$style.getStroke()) {
        this.$style.setStroke(stroke);
        this.scheduleRefresh();
      }
    }
  },
  stubVNode: {
    empty: false,
    attrs: function attrs() {
      return {
        id: this.vmId,
        class: this.cmpName
      };
    }
  }
};

export default withFillStrokeStyle;
